<template>
  <div class="animated fadeIn">
    <b-row class="mb-0 mt-0 pt-1">
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Date</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="current_seating.DateOfSeating"
              autocomplete="off"
              type="text"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Restaurant</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="current_seating.Restaurant.Name"
              autocomplete="off"
              type="text"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Type</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="current_seating.SeminarType.SeminarTypeName"
              autocomplete="off"
              type="text"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Cluster</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="current_seminar.ClusterDescription"
              autocomplete="off"
              type="text"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-0 mt-0 pt-1">
      <b-col md="12">
        <span class="tabtext font-weight-bold">Prospects</span>
      </b-col>
    </b-row>
    <hr />
     <b-row class="mb-0 mt-0 pt-1">
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Meal Cost</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PMealCost"
              autocomplete="off"
              type="text"
              id="PMealCost"
              @change.native="saveField"
              v-mask="'?#?#?#?#?#?#?#?#?#?.?#?#'"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Attendees</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PConfirmedAttendees"
              autocomplete="off"
              type="text"
              id="PConfirmedAttendees"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Buying Units</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PConfirmedBuyingUnits"
              autocomplete="off"
              type="text"
              id="PConfirmedBuyingUnits"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Yes-Sheets</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PConfirmedYesSheets"
              autocomplete="off"
              type="text"
              id="PConfirmedYesSheets"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-0 mt-0 pt-1">
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Appts Set</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PConfirmedAppointments"
              autocomplete="off"
              type="text"
              id="PConfirmedAppointments"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Appts Set (7 Days)</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PConfirmedImmediateAppointments"
              autocomplete="off"
              type="text"
              id="PConfirmedImmediateAppointments"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Appts Kept</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PConfirmedKeptAppointments"
              autocomplete="off"
              type="text"
              id="PConfirmedKeptAppointments"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Appts Kept (7 Days)</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PConfirmedKeptImmediateAppointments"
              autocomplete="off"
              type="text"
              id="PConfirmedKeptImmediateAppointments"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-0 mt-0 pt-1">
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Wrote Business</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PBusinessWritten"
              autocomplete="off"
              type="text"
              id="PBusinessWritten"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Wrote Business (7 Days)</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PBusinessWrittenImmediate"
              autocomplete="off"
              type="text"
              id="PBusinessWrittenImmediate"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Prem. Submitted</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PProductionSubmitted"
              autocomplete="off"
              type="text"
              id="PProductionSubmitted"
              v-mask="'?#?#?#?#?#?#?#?#?#?.?#?#'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Prem. Submitted (7 Days)</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PProductionSubmittedImmediate"
              autocomplete="off"
              type="text"
              id="PProductionSubmittedImmediate"
              v-mask="'?#?#?#?#?#?#?#?#?#?.?#?#'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
        <b-row class="mb-0 mt-0 pt-1">
      <b-col md="6">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Total Paid Premium</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.PTotalPremium"
              autocomplete="off"
              type="text"
              id="PTotalPremium"
              v-mask="'?#?#?#?#?#?#?#?#?#?.?#?#'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
        </b-row>

    <b-row class="mb-0 mt-0 pt-1">
      <b-col md="12">
        <span class="tabtext font-weight-bold">Clients</span>
      </b-col>
    </b-row>
    <hr />
    <b-row class="mb-0 mt-0 pt-1">
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Meal Cost</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.MealCost"
              autocomplete="off"
              type="text"
              id="MealCost"
              @change.native="saveField"
              v-mask="'?#?#?#?#?#?#?#?#?#?.?#?#'"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Attendees</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ConfirmedAttendees"
              autocomplete="off"
              type="text"
              id="ConfirmedAttendees"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Buying Units</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ConfirmedBuyingUnits"
              autocomplete="off"
              type="text"
              id="ConfirmedBuyingUnits"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Yes-Sheets</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ConfirmedYesSheets"
              autocomplete="off"
              type="text"
              id="ConfirmedYesSheets"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-0 mt-0 pt-1">
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Appts Set</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ConfirmedAppointments"
              autocomplete="off"
              type="text"
              id="ConfirmedAppointments"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Appts Set (7 Days)</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ConfirmedImmediateAppointments"
              autocomplete="off"
              type="text"
              id="ConfirmedImmediateAppointments"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Appts Kept</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ConfirmedKeptAppointments"
              autocomplete="off"
              type="text"
              id="ConfirmedKeptAppointments"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Appts Kept (7 Days)</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ConfirmedKeptImmediateAppointments"
              autocomplete="off"
              type="text"
              id="ConfirmedKeptImmediateAppointments"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-0 mt-0 pt-1">
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Wrote Business</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.BusinessWritten"
              autocomplete="off"
              type="text"
              id="BusinessWritten"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Wrote Business (7 Days)</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.BusinessWrittenImmediate"
              autocomplete="off"
              type="text"
              id="BusinessWrittenImmediate"
              v-mask="'###'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Prem. Submitted</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ProductionSubmitted"
              autocomplete="off"
              type="text"
              id="ProductionSubmitted"
              v-mask="'?#?#?#?#?#?#?#?#?#?.?#?#'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Prem. Submitted (7 Days)</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.ProductionSubmittedImmediate"
              autocomplete="off"
              type="text"
              id="ProductionSubmittedImmediate"
              v-mask="'?#?#?#?#?#?#?#?#?#?.?#?#'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
        <b-row class="mb-0 mt-0 pt-1">
      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Total Paid Premium</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="current_seating.TotalPremium"
              autocomplete="off"
              type="text"
              id="TotalPremium"
              v-mask="'?#?#?#?#?#?#?#?#?#?.?#?#'"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
        </b-row>
    <hr />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "AppointmentRow",
  components: {},
  props: {
    seating_object: { type: Object },
    seminar_object: { type: Object }
  },
  data() {
    return {
      current_seating: this.seating_object,
      current_seminar: this.seminar_object,
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    saveField: function(event) {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        SeatingID: this.current_seating.SeatingID,
        FieldToSet: event.target.id,
        ValueToSet: event.target.value
      };

      this.$store.dispatch("seminar/SaveSeating", _operation).then();
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    }
  },
  computed: {
    ...mapState(["seminar", "territory", "n_user"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  created() {},
  watch: {},
  mounted() {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
